<template>
  <div
    class="stores-and-events-index"
    :class="{ 'no-top-padding': isMobileApp }"
  >
    <Banner page="stores_and_events_index_page" />
    <ListingCardContainer>
      <ListingCard>
        <ListingCardItem
          :title="$t('retailStore.events')"
          :description="$t('retailStore.eventsDescription')"
          :image-src="discoverStoreEventImage"
          :is-web="isWeb"
          :show-description="true"
          :router-link="{ name: 'discover-event-index' }"
          :button-text="$t('buttons.moreDetails')"
        />
      </ListingCard>
      <ListingCard>
        <template v-if="isMobileApp">
          <ListingCardItem
            :title="$t('retailStore.findStore')"
            :description="$t('retailStore.findStoreDescription')"
            :image-src="findAStoreImage"
            :is-web="isWeb"
            :show-description="true"
            :link="'sephora://store-locations'"
            :button-text="$t('buttons.moreDetails')"
          />
        </template>
        <template v-else>
          <ListingCardItem
            :title="$t('retailStore.findStore')"
            :description="$t('retailStore.findStoreDescription')"
            :image-src="findAStoreImage"
            :is-web="isWeb"
            :show-description="true"
            :router-link="{ name: 'store-location-index' }"
            :button-text="$t('buttons.moreDetails')"
          />
        </template>
      </ListingCard>
      <!-- This page has no deeplink because mobile app don't have a native page for it unlike Store event and store location. -->
      <ListingCard>
        <template v-if="!isEmpty(beautyClasses)">
          <ListingCardItem
            :title="$t('retailStore.classes')"
            :description="$t('retailStore.beautyClassesDescription')"
            :image-src="beautyClassesImage"
            :is-web="isWeb"
            :show-description="true"
            :router-link="{ name: 'beauty-classes-index' }"
            :button-text="$t('buttons.moreDetails')"
          />
        </template>
      </ListingCard>
      <template v-if="!isEmpty(pages)">
        <ListingCard
          v-for="page in pages"
          :key="page.id"
        >
          <ListingCardItem
            :title="page.attributes['page-title']"
            :description="page.attributes['dropdown-description']"
            :image-src="page.attributes.image"
            :is-web="isWeb"
            :show-description="true"
            :router-link="{ name: 'stores-and-events-show', params: { id: page.attributes['slug-url'] }}"
            :button-text="$t('buttons.moreDetails')"
          />
        </ListingCard>
      </template>
    </ListingCardContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import isEmpty from 'lodash/isEmpty'
import discoverStoreEventImage from '../../assets/images/booking-service/discover-store-events.jpg'
import findAStoreImage from '../../assets/images/booking-service/find-a-store.jpg'
import beautyClassesImage from '../../assets/images/booking-service/beauty-classes.jpg'
import Banner from './reusable/banner.vue'
import ListingCard from './ListingCard.vue'
import ListingCardContainer from './ListingCardContainer.vue'
import ListingCardItem from './ListingCardItem.vue'
import { fullUrl } from '@/modules/services/utilities'

export default {
  name: 'StoresAndEventsIndex',
  components: {
    Banner,
    ListingCard,
    ListingCardContainer,
    ListingCardItem
  },
  data () {
    return {
      discoverStoreEventImage: discoverStoreEventImage,
      findAStoreImage: findAStoreImage,
      beautyClassesImage: beautyClassesImage,
      isEmpty: isEmpty
    }
  },
  computed: {
    ...mapGetters(['isMobileApp', 'isWeb']),
    ...mapGetters('bookingService', ['pages', 'beautyClasses'])
  },
  mounted () {
    this.$store.commit('setSeoMetaTitle', this.$t('retailStore.storesAndEvents'))
    const country = this.$t('country', I18n.siteCountryLs)
    this.$store.commit(
      'setSeoMetaDescription',
      this.$t('bookingService.metaDescription', { country: country })
    )
    this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
    this.$store.commit('setSeoUpdate', true)
  }
}
</script>

<style lang='scss' scoped>
.stores-and-events-index {
  @include media-breakpoint-down(md) {
    padding-right: 5px;
    padding-left: 5px;
  }

  @include media-breakpoint-down(sm) {
    padding: 10px;
  }

  &.no-top-padding {
    padding-top: 0;
  }
}
</style>
